import React from "react";
import { CircleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

interface ErrorStateProps {
  title?: string;
  message?: string;
  buttonCta?: string;
  onRetry?: () => void;
  minH?: string | number;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = "Something went wrong.",
  message = "An unexpected error has occurred. Please refresh the page or try again later.",
  buttonCta = "Refresh Page",
  onRetry = () => window.location.reload(),
  minH = "60vh"
}) => {
  const shouldRenderMessage =
    typeof message === "string" && message.trim().length > 0;
  const shouldRenderButton =
    typeof buttonCta === "string" && buttonCta.trim().length > 0;

  return (
    <EmptyState
      icon={CircleAlert}
      title={title}
      description={shouldRenderMessage ? message : undefined}
      action={
        shouldRenderButton ? (
          <Button variant="primary" onClick={onRetry}>
            {buttonCta}
          </Button>
        ) : undefined
      }
      style={{ minHeight: minH }}
    />
  );
};
